import { StatsPieChart } from "./CategoryBreakdownPieChart";

export default StatsPieChart;
